export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/contraloriaccion.jpg',
	   "funcion": 'Contraloria en Acción.',
		"url" : 'https://www.facebook.com/share/v/1N2wy5Jn71/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/rutastransformacion.jpg',
	   "funcion": 'Rutas de la Transformación.',
		"url" : 'https://www.facebook.com/share/p/1DuC7a8V4M/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/8marzo.jpg',
	   "funcion": 'Podcast',
		"url" : 'https://www.facebook.com/share/v/18Ux6CPgNQ/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]